import React, { useState } from 'react';

const ScrollTopButton = () => {

    const [visible, setVisible] = useState(false)

    const toggleVisible = () => {
        const scrolled = document.documentElement.scrollTop || document.body.scrollTop;
        if (scrolled > 30) {
            setVisible(true)
        }
        else if (scrolled <= 30) {
            setVisible(false)
        }
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
            /* you can also use 'auto' behaviour
               in place of 'smooth' */
        });
    };

    window.addEventListener('scroll', toggleVisible);

    return (
        <div>
            <button id="myBtn" onClick={scrollToTop}
                style={{ display: visible ? 'flex' : 'none' }}
                className='justify-content-center'
            >
                <img className='align-self-center' id="scroll-to-arrow" src='/assets/icons/arrow-up.svg' />
            </button >
        </div>
    );
}

export default ScrollTopButton;